export default __webpack_public_path__ + "static/media/training.b2c877da.jpg";